module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0008.jpg?v=ec4ab82b";